/* eslint-disable eqeqeq */
import React, {useEffect, useState, useRef, useCallback, useMemo} from 'react'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import {useTranslation} from 'react-i18next'
import axios from 'axios'
// import {Editor} from '@tinymce/tinymce-react'
import Pagination from '../../component/Pagination'
import {deleteLetter, deleteOptionalText, updateLetter, updateOptionalText} from '../../../../api/modules/letterconfig'
import swal from 'sweetalert'
import {Spinner} from 'react-bootstrap'
import {useAppDispatch, useAppSelector} from '../../../../redux/hooks'
import {objToParams} from '../../../../utils/objToParams'
import {fetchConfigLetter, fetchConfigOptionalText, headers} from '../../../../services/fetcher'
import {RowFilter} from './RowFilter'
import {RowHead} from './RowHead'
import {ButtonGroups} from './ButtonGroups'
import {
  filterSelector,
  resetFilterConfigLetter,
  resetFilterConfigOptionalText,
  setIsFetchData,
} from '../../../../redux/slices/filterSlices'
import * as TableUI from '../../../../components/Table/Table'
import {useRowTable} from '../../../../hooks/useRowTable'
import {StyledCard} from '../../../../components/StyledCard'
import {RowData, RowDataProps} from './RowData'
import {useLoaderList} from 'src/hooks/useLoaderList'

import Editor from 'src/app/components/Editor'
import { getOptionalTextModules } from 'src/api/modules/getdatalist'

type Props = {
  className: string
}

const TableLetter: React.FC<Props> = ({className}) => {
  const {t} = useTranslation()
  const {filterConfigOptionalText: filter} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()

  const {RowEmptyData, RowErrorFetch, RowLoader} = useRowTable({
    colSpan: 7,
    onReloadTable: () => dispatch(resetFilterConfigOptionalText()),
  })

  const {
    isLoadingEditButton,
    onInitializeLoaderList,
    onResetLoaderList,
    onUpdateLoaderListByIndex,
  } = useLoaderList()

  const [page, setPage] = useState(0)
  const [btnLoading, setBtnLoading] = useState(false)
  const [numberURL, setNumberURL] = useState([])
  const [sales, setSales] = useState('')
  const [salesDesc, setSalesDesc] = useState('')
  const [sector, setSector] = useState('')
  const [sectorDesc, setSectorDesc] = useState('')
  const [module, setModule] = useState('')
  const [content, setContent] = useState('')
  const [tempID, setTempID] = useState(0)
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(true)

  const [allLetter, setAllLetter] = useState<any[]>([])
  const [showEdit, setShowEdit] = useState(false)
  const [showDelete, setShowDelete] = useState(false)

  const [listmodule, setListModule] = useState<any[]>([])

  const rowNumber = useMemo(() => {
    const per = filter?.per_page ?? 5
    return page * per - per
  }, [filter, page])

  const editorRef: any = useRef()

  const handleEdit = async () => {
    setBtnLoading(true)

    let formdata = new FormData()

    formdata.append('module', module!)
    formdata.append('sales_org_code', sales!)
    formdata.append('sector_id', sector!)
    formdata.append('content', content!)

    await updateOptionalText(tempID, formdata)
      .then((res) => {
        onFetchConfigLetter()
        swal({
          title: `${t('configuration-edited')}`,
          icon: 'success',
        }).then(() => {
          setActived(!actived)
          setShowEdit(false)
        })
      })
      .catch((error) => {
        swal({
          closeOnClickOutside: false,
          title: t(error.response.data.message),
          icon: 'error',
        })
      })
      .finally(() => setBtnLoading(false))
  }

  const handleDelete = async (id: any) => {
    swal({
      title: t('Are you sure?'),
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Yes')}`],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        setBtnLoading(true)
        await deleteOptionalText(id)
          .then((res) => {
            onFetchConfigLetter()
            swal({
              title: t('configuration-deleted'),
              icon: 'success',
            })
            setShowDelete(false)
            setActived(!actived)
          })
          .catch(function (error) {
            if (error.response) {
              swal({
                title: `${error.response.data.message}`,
                icon: 'error',
              })
            }
          })
          .finally(() => setBtnLoading(false))
      }
    })
  }

  const paginateNumber = async (url: string) => {
    try {
      setIsLoading(true)

      const token = localStorage.getItem('token') as string
      const credentials = localStorage.getItem('credential') as string
      const endpoint = `${url}&credentials=${credentials}&${objToParams(filter)}`
      const res = await axios.get(endpoint, {
        headers: {...headers, Authorization: `Bearer ${token}`},
      })

      setAllLetter(res.data.data.data)
      setPage(res.data.data.current_page)
      setNumberURL(res.data.data.links)
      onInitializeLoaderList(res.data.data.data)
    } catch (error) {
      setIsError(true)
    } finally {
      setIsLoading(false)
    }
  }

  const [actived, setActived] = useState(false)

  const onEdit = (data: RowDataProps['data']) => {
    setTempID(data?.id)
    setSales(data?.sales_org_code ?? '')
    setSalesDesc(data?.sales_org?.name ?? '')
    setSector(data?.sector_id)
    setSectorDesc(data?.sector?.name)
    setModule(data?.module ?? '')
    setContent(data?.content ?? '')
    setShowEdit(true)
  }

  const onDelete = (data: RowDataProps['data']) => {
    setTempID(data.id)
    handleDelete(data.id)
  }

  const onFetchConfigLetter = useCallback(() => {
    setIsLoading(true)
    setIsError(false)

    fetchConfigOptionalText(filter)
      .then((res) => {
        setAllLetter(res.data.data.data)
        setPage(res.data.data.current_page)
        setNumberURL(res.data.data.links)
        onInitializeLoaderList(res.data.data.data)
      })
      .catch(() => setIsError(true))
      .finally(() => {
        setIsLoading(false)
        dispatch(setIsFetchData(false))
      })
  }, [filter, dispatch])

  useEffect(() => {
    const getData = setTimeout(onFetchConfigLetter, 1000)
    return () => clearTimeout(getData)
  }, [onFetchConfigLetter])

  const handleResetTable = () => {
    dispatch(resetFilterConfigLetter())
  }

  useEffect(() => {
    const getModules = async () => {
      const res = await getOptionalTextModules()
      setListModule(res.data.data?.map((item: any) => {
        return {
          label: item,
          value: item
        }
      }))
    }
    getModules()

    return () => {
      handleResetTable()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <StyledCard>
      <ButtonGroups />

      <TableUI.TableWrapper>
        <TableUI.Table>
          <TableUI.THead>
            <RowHead />
          </TableUI.THead>
          <TableUI.TBody>
            <RowFilter />
            {isLoading ? (
              <RowLoader />
            ) : isError ? (
              <RowErrorFetch />
            ) : allLetter.length === 0 ? (
              <RowEmptyData />
            ) : (
              allLetter.map((data: any, idx: number) => (
                <RowData
                  key={idx}
                  data={data}
                  rowNumber={idx + rowNumber + 1}
                  onEdit={() => {
                    onEdit(data)
                    onUpdateLoaderListByIndex(idx)
                  }}
                  onDelete={() => onDelete(data)}
                />
              ))
            )}
          </TableUI.TBody>
        </TableUI.Table>
      </TableUI.TableWrapper>

      <Pagination paginate={paginateNumber} test={numberURL} />

      <Modal
        show={showEdit}
        onHide={() => setShowEdit(false)}
        backdrop='static'
        keyboard={false}
        centered
        size='lg'
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {t('Edit')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
                  
          <Row className='mb-5'>
            <Col sm={3}>
              <Form.Label>{t('Module')}</Form.Label>
            </Col>
            <Col sm={9}>
              <Form.Select
                aria-label='Default select example'
                disabled
                onChange={(e: any) => setModule(e.target.value)}
              >
                <option selected hidden value=''>
                  {t('pilih')} {t('Module')}
                </option>
                {listmodule.map((data: any, index: number) => {
                  return (
                    <option
                      key={data?.value ?? index}
                      selected={data.value == module}
                      value={data.value}
                    >
                      {t(data.label)}
                    </option>
                  )
                })}
              </Form.Select>
            </Col>
          </Row>

          <Row className='mb-5'>
            <Col sm={3}>
              <Form.Label>Sales Org</Form.Label>
            </Col>
            <Col sm={9}>
              <Form.Control placeholder='Sales Org' disabled value={salesDesc} />
            </Col>
          </Row>

           <Row className='mb-5'>
            <Col sm={3}>
              <Form.Label>Sector</Form.Label>
            </Col>
            <Col sm={9}>
              <Form.Control placeholder='Sector' disabled value={sectorDesc} />
            </Col>
          </Row>
          
          <Row className='mb-5'>
            <Col sm={3}>
              <Form.Label>Body/{t('Content')}</Form.Label>
            </Col>
            <Col sm={9}>
            <Editor
                  data={content}
                  onChange={ ( content ) => {
                      setContent(content)
                  }}
              />
            </Col>
          </Row>

          <div className='d-flex justify-content-end'>
            <Button variant='primary' onClick={() => handleEdit()} disabled={btnLoading}>
              {btnLoading ? (
                <Spinner animation='border' variant='light' size='sm' />
              ) : (
                <>{t('Edit')}</>
              )}
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={showDelete} onHide={() => setShowDelete(false)} centered backdrop='static'>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <h3 className='text-center mb-5'>
            {t('Hapus')} {t('Configuration Letter')}?
          </h3>
          <div className='d-flex justify-content-center'>
            <Button variant='secondary me-2' onClick={() => setShowDelete(false)}>
              {t('Tidak')}
            </Button>
            <Button variant='danger' onClick={() => deleteLetter()} disabled={btnLoading}>
              {btnLoading ? <Spinner animation='border' variant='light' size='sm' /> : t('Ya')}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </StyledCard>
  )
}

export {TableLetter}
